import React from "react";
import "./achievements.css";
import Blueline from "../../assets/blueline.svg";
import Badges from "./badges";
import Certificates from "./certificates";
import _ from "lodash";

const Achievements = () => {
  const badgeGroups = _.chunk(Badges, 6);
  return (
    <div className="achiv">
      <div className="skill-title">
        <div className="name">
          My <span className="blue-text">Achievements</span>
        </div>
        <img className="b-line" src={Blueline} alt="line" />
      </div>
      <div className="badges">
        {badgeGroups.map((group, index) => {
          const isEvenGroup = index % 2 === 0;
          const groupClass = isEvenGroup
            ? "badge-group-left"
            : "badge-group-right";
          return (
            <div key={index} className={`badge-group ${groupClass}`}>
              {group.map((item) => {
                return (
                  <img
                    className="badge-img"
                    onClick={() => {
                      window.open(item.url);
                    }}
                    key={item.img}
                    src={item.img}
                    alt=""
                  />
                );
              })}
            </div>
          );
        })}
      </div>
      <div className="cert-main">
        {Certificates.map((item) => {
          return (
            <img
              className="cert"
              src={item.img}
              onClick={() => {
                window.open(item.url);
              }}
              alt=""
            />
          );
        })}
      </div>
    </div>
  );
};

export default Achievements;
